import { ITicker } from '@kattana-io/common';
import Text from '../../../atoms/Text';
import { toFixed2 } from '../../DexTrades/formatters';
import usePriceChange from '../../Info/usePriceChange';
import { getPriceChangeArgs } from '../DailyPriceChange';
import useTickerLivePrice from '../useTickerLivePrice';

interface IDailyPriceChangeMobile {
  ticker: ITicker;
}

const DailyPriceChangeMobile = (props: IDailyPriceChangeMobile) => {
  const { price } = useTickerLivePrice(props.ticker);

  const { chain, address } = getPriceChangeArgs(props.ticker);

  const { priceChangePercent } = usePriceChange(
    Number(price.slice(1)),
    props.ticker.flipped,
    chain,
    address
  );

  // Return nothing if price didn't changed
  if (priceChangePercent === 0) {
    return (
      <Text className='text--grey-400 text--weight-500' size={14}>
        {price}
      </Text>
    );
  }

  return (
    <div className='price__change_cell'>
      <Text
        className={`text--${
          priceChangePercent < 0 ? 'red-700' : 'green-600'
        } text--weight-500`}
        size={14}
      >
        {price}
      </Text>
      <Text
        className={`text--${
          priceChangePercent < 0 ? 'red-700' : 'green-600'
        } text--weight-400`}
        size={12}
      >
        {toFixed2(priceChangePercent)}%
      </Text>
    </div>
  );
};

export default DailyPriceChangeMobile;
